import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

// Register required Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ data }) => {
    // Extract labels (months) and values from the provided data
    const labels = Object.keys(data);
    const values = Object.values(data);

    // Calculate the scale factor dynamically for large numbers
    const maxValue = Math.max(...values.map((value) => parseFloat(value || 0)));
    const scaleFactor = maxValue > 1000 ? Math.pow(10, Math.floor(Math.log10(maxValue / 100))) : 1;

    // Prepare chart dataset
    const chartData = {
        labels, // Use months as X-axis labels
        datasets: [
            {
                label: "Amount",
                data: values.map((value) => parseFloat(value || 0) / scaleFactor), // Scale down values
                backgroundColor: "#36A2EB",
                barThickness: 15,
                borderRadius: 5,
            },
        ],
    };

    // Chart.js configuration
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
            },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    title: (tooltipItems) => `Month: ${tooltipItems[0].label}`, // Tooltip title with month
                    label: (context) => {
                        const rawValue = context.raw * scaleFactor; // Scale back the value for the tooltip

                        // Format the value as K, L, Cr
                        let formattedValue;
                        if (rawValue >= 10000000) formattedValue = `${(rawValue / 10000000).toFixed(1)} Cr`;
                        else if (rawValue >= 100000) formattedValue = `${(rawValue / 100000).toFixed(1)} L`;
                        else if (rawValue >= 1000) formattedValue = `${(rawValue / 1000).toFixed(1)} K`;
                        else formattedValue = rawValue;

                        return `Amount: ${formattedValue}`;
                    },
                },
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, // Remove vertical gridlines
                },
            },
            y: {
                beginAtZero: true,
                ticks: {
                    callback: (value) => value, // Show scaled-down values on the y-axis
                },
            },
        },
    };

    return (
        <div style={{ height: "14rem", width: "100%" }}>
            <Bar data={chartData} options={chartOptions} />
        </div>
    );
};

export default BarChart;
